module.exports = __webpack_public_path__ + "img/banque.f17eb6cd.png";